import index from "../index/fr.js"
import login from "../login/fr.js"
import projectList from "../projectList/fr.js"
import post from "../post/fr.js"
import admin from "../admin/fr.js"
import outputFile from "../outputFile/fr.js"
import dashboard from "../dashboard/fr.js"
import explan from "../explan/fr.js"

export default {
  index,
  login,
  projectList,
  post,
  admin,
  outputFile,
  dashboard,
  explan
}



// WEBPACK FOOTER //
// ./src/locale/lang/fr.js